import { cn } from "@/components/ui/utils";
import type { TripwirePin } from "@/utils/tripwireBadge";

export function CapabilityStateControl({
  value,
  onChange,
  denyLabel = "Deny",
  disabled = false,
  id,
}: {
  value: TripwirePin;
  onChange: (next: TripwirePin) => void;
  denyLabel?: string;
  disabled?: boolean;
  id?: string;
}) {
  const options: { value: TripwirePin; label: string }[] = [
    { value: "inherit", label: "Inherit" },
    { value: "allow", label: "Allow" },
    { value: "deny", label: denyLabel },
  ];

  return (
    <div
      id={id}
      className="inline-flex rounded-md border border-input p-0.5"
      role="radiogroup"
    >
      {options.map((option) => {
        const selected = value === option.value;
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={selected}
            disabled={disabled}
            className={cn(
              "rounded-sm px-2.5 py-1 text-xs font-medium",
              selected
                ? "bg-primary text-primary-foreground"
                : "text-muted-foreground hover:bg-accent hover:text-accent-foreground",
            )}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
